// Auto-generated skeleton for MailTemplate

export const MailTemplate: Api.MailTemplate = {
  id: 0,
  type: null,
  subject: '',
  body: '',
  cc: null,
  reply_to: null,
  footer: null,
  mail_from_address: null,
  mail_from_name: null,
  created: null,
  updated: null,
};

